import { render, staticRenderFns } from "./EditEventContactForm.vue?vue&type=template&id=e12159a2&"
import script from "./EditEventContactForm.vue?vue&type=script&lang=js&"
export * from "./EditEventContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditEventContactForm.vue"
export default component.exports